__turbopack_context__.v({
  "fullWidthWrap": "FullWidthWrap-module-scss-module__bSI7NG__fullWidthWrap",
});
